export const config = {
  limit: 50,
  dataGrid: {
    rowsPerPageOptions: [10, 25, 50, 100]
  }
}
